import * as actions from 'actions/PrexoActions/productExchangeActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import { createV4Reducer } from 'reducers/PageDataReducers/miscPageDataReducers';
import { BrandSearchToggleAction } from 'actions/PrexoActions/BrandSearchActions';
import { createReducer } from 'utils/reducerUtils';
import { UPDATE_ANSWER, CLEAR_ANSWER } from 'actions/PrexoActions/updateAnswerActions';
const defaultState = {
    asyncStatus: AsyncStatus.INIT
};
export function verifyIMEIReducer(state = defaultState, action) {
    switch (action.type) {
        case actions.verifyIMEIActions.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING
            });
        case actions.verifyIMEIActions.SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.SUCCESS
            }, action.data);
        case actions.verifyIMEIActions.ERROR:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.ERROR
            }, action.error);
        case actions.verifyIMEIActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
export function brandSearchReducer(state = defaultState, action) {
    switch (action.type) {
        case BrandSearchToggleAction.SHOW:
            return Object.assign({}, state, {
                showBrandSearch: true
            });
        case BrandSearchToggleAction.HIDE:
            return Object.assign({}, state, {
                showBrandSearch: false
            });
        default:
            return state;
    }
}
export const exchangeTermsInfo = createReducer(actions.exchangeTermsActions.REQUEST, actions.exchangeTermsActions.SUCCESS, actions.exchangeTermsActions.ERROR, defaultState);
export const exchangeTooltipReducer = createV4Reducer(actions.EXCHANGE_TOOLTIP_ACTIONS.REQUEST, actions.EXCHANGE_TOOLTIP_ACTIONS.SUCCESS, actions.EXCHANGE_TOOLTIP_ACTIONS.ERROR, actions.EXCHANGE_TOOLTIP_ACTIONS.CLEAR);
/** Update Exchange Answer reducer */
export function updateExchangeAnswer(state = {}, action = {}) {
    switch (action.type) {
        case UPDATE_ANSWER:
            return action;
        case CLEAR_ANSWER:
            return {};
        default:
            return state;
    }
}
